var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryJp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.11C8 17.175 8.20977 18.2296 8.61734 19.2136C9.0249 20.1975 9.62228 21.0916 10.3754 21.8447C11.1285 22.5977 12.0225 23.1951 13.0064 23.6027C13.9904 24.0103 15.045 24.22 16.11 24.22C17.175 24.22 18.2296 24.0103 19.2136 23.6027C20.1975 23.1951 21.0916 22.5977 21.8447 21.8447C22.5977 21.0916 23.1951 20.1975 23.6027 19.2136C24.0103 18.2296 24.22 17.175 24.22 16.11C24.22 13.9591 23.3656 11.8963 21.8447 10.3754C20.3237 8.85445 18.2609 8 16.11 8C13.9591 8 11.8963 8.85445 10.3754 10.3754C8.85444 11.8963 8 13.9591 8 16.11Z",
    fill: "#C01D3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#D7D7D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryJp);
export default __webpack_public_path__ + "static/media/country-jp.e6cd0578.svg";
export { ForwardRef as ReactComponent };